import * as mutation_types from '../mutation-types'
import * as action_types from '../action-types'

// initial state
const state = {
    question_cnt: 0,
    modules: []
}

const actions = {}

// mutations
const mutations = {
    [mutation_types.MODULES_SET] (state, {modules, question_cnt}) {
        state.modules = modules;
        state.question_cnt = question_cnt;
    },
}

export default {
    state,
    actions,
    mutations
}
